import { render, staticRenderFns } from "./expandableCriteresRecus.vue?vue&type=template&id=0f192bbe&"
import script from "./expandableCriteresRecus.vue?vue&type=script&lang=ts&"
export * from "./expandableCriteresRecus.vue?vue&type=script&lang=ts&"
import style0 from "./expandableCriteresRecus.vue?vue&type=style&index=0&id=0f192bbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports